export const mobileConstants = {
    LOAD_REQUEST: 'MOBILE_LOAD_REQUEST',
    LOAD_SUCCESS: 'MOBILE_LOAD_SUCCESS',
    LOAD_FAILURE: 'MOBILE_LOAD_FAILURE',

    SELECT_REQUEST: 'MOBILE_SELECT_REQUEST',

    DELETE_REQUEST: 'MOBILE_DELETE_REQUEST',
    DELETE_SUCCESS: 'MOBILE_DELETE_SUCCESS',
    DELETE_FAILURE: 'MOBILE_DELETE_FAILURE',

    COUNT_REQUEST: 'MOBILE_COUNT_REQUEST',
    COUNT_SUCCESS: 'MOBILE_COUNT_SUCCESS',
    COUNT_FAILURE: 'MOBILE_COUNT_FAILURE',

}
